import Nav from "@/components/Header/Nav/Nav.tsx";
import Footer from "@/components/Footer/Footer.tsx";
import GridComponent from "@/components/GridComponent/GridComponent";
import ImageContainer from "@/components/ImageContainer/ImageContainer";
import DoubleBlock from "@/components/DoubleBlock/DoubleBlock";
import PartnerForm from "@/components/ContactForm/PartnerForm";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import CookiePopupButton from "../components/CookieBanner/CookiePopupButton";
import { Helmet } from "react-helmet";

const Partner = () => {
  const { t } = useTranslation("pages");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const gridItems = t("partner.grid.items", { returnObjects: true }) as Array<{
    title: string;
    description: string;
  }>;

  const gridData = [
    {
      icon: "/images/Grid/garant-ico.svg",
      title: gridItems[0].title,
      description: gridItems[0].description,
    },
    {
      icon: "/images/Grid/diagram-pers-ico.svg",
      title: gridItems[1].title,
      description: gridItems[1].description,
    },
    {
      icon: "/images/Grid/calculate-ico.svg",
      title: gridItems[2].title,
      description: gridItems[2].description,
    },
    {
      icon: "/images/Grid/check-ui-ico.svg",
      title: gridItems[3].title,
      description: gridItems[3].description,
    },
    {
      icon: "/images/Grid/graph-ico.svg",
      title: gridItems[4].title,
      description: gridItems[4].description,
    },
    {
      icon: "/images/Grid/deliv-ico.svg",
      title: gridItems[5].title,
      description: gridItems[5].description,
    },
  ];

  return (
    <div>
      <Helmet>
        <title>{t("partner.meta.title")}</title>
      </Helmet>

      <Nav></Nav>
      <DoubleBlock
        leftTitle={t("partner.hero.leftTitle")}
        rightText={t("partner.hero.rightText")}
      ></DoubleBlock>
      <ImageContainer src="/images/partner-img.webp" alt="Partner" />
      <GridComponent
        items={gridData}
        title={t("partner.grid.title")}
      ></GridComponent>
      <PartnerForm></PartnerForm>
      <CookiePopupButton></CookiePopupButton>
      <Footer></Footer>
    </div>
  );
};

export default Partner;
